import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, ContentPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { ScrollView } from "./scroll-view"

export class ScrollComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Scroll';
        this.canAcceptContent = true;
        this.canAcceptMultipleContent = false;

        this.addProperty("Content","",new ContentPropertyType(this),null,true);
        this.addProperty("AllowHorizontal","data-b-comp-horizontal",new BooleanPropertyType(this),false,false);
        this.addProperty("AllowVertical","data-b-comp-vertical",new BooleanPropertyType(this),true,false);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ScrollViewModel(parent);
        return result;
    }
        
}
export class ScrollViewModel extends ChildAcceptableFormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ScrollView();
    }
    public getTypeId(): string {
        return "VM-AEE2D09C-B262-4339-83BF-5C84ECEEE15B"
    }

    
    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set AllowHorizontal(v: boolean) { this._AllowHorizontal = v; } public get AllowHorizontal(): boolean { return this._AllowHorizontal;} private _AllowHorizontal: boolean;
    public set AllowVertical(v: boolean) { this._AllowVertical = v; } public get AllowVertical(): boolean { return this._AllowVertical;} private _AllowVertical: boolean;
            
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitScroll(this,parameter);
    }
    addChildInternal(element: FormBuilderElement): void {
        this.children.update(...[element]);
        this.Content = element;
    }
    removeChild(element: FormBuilderElement): void {
        if(element && this.Content &&this.Content.self == element.self){
            this.children.clear();
            this.Content = null;
        }
    }
}
